module.exports = __webpack_public_path__ + "img/sh_9.18783017.jpg";